import React from 'react'
import { render } from 'react-dom'
import App from 'Containers/App/App'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import TagManager from 'react-gtm-module'
import { createBrowserHistory } from 'history'
import CreateStore from 'Redux/index'
import { PersistGate } from 'redux-persist/integration/react'
import * as Sentry from '@sentry/react'
import { Integrations } from '@sentry/tracing'
import { APP as apiConfig } from 'Configs/App'
import 'Localization/i18n'
import ModalProvider from './Containers/App/ModalProvider'

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: apiConfig.SENTRY_DSN,
    autoSessionTracking: true,
    integrations: [new Integrations.BrowserTracing({})],
    tracesSampleRate: 1.0,
    //  eslint-disable-next-line @typescript-eslint/no-explicit-any
    beforeSend: event => event,
    release: 'react@sc-2022.23',
    environment: 'production',
  })
}

// if (process.env.NODE_ENV === 'development') {
//   Sentry.init({
//     dsn: apiConfig.SENTRY_DSN,
//     autoSessionTracking: true,
//     integrations: [new Integrations.BrowserTracing({})],
//     tracesSampleRate: 1.0,
//     //  eslint-disable-next-line @typescript-eslint/no-explicit-any
//     beforeSend: event => event,
//     release: 'react@sc-2022.22_dev',
//     environment: 'development',
//   })
// }

const { store, persistor } = CreateStore()
const history = createBrowserHistory()
// eslint-disable-next-line no-undef
const host = window.location.hostname
// eslint-disable-next-line @typescript-eslint/no-explicit-any,no-restricted-globals
const path = (/#!(\/.*)$/.exec(location.hash) || [])[1]

TagManager.initialize({
  // @ts-ignore
  gtmId: apiConfig.GTM_CONTAINER,
})

if (path) {
  history.replace(path)
}

render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter>
        <ModalProvider>
          <App history={history} />
        </ModalProvider>
      </BrowserRouter>
    </PersistGate>
  </Provider>,
  // eslint-disable-next-line no-undef
  document.getElementById('root')
)
